import axiosClient from "./axiosClient";

export const getFeelings = async (userId) => {
  const response = await axiosClient.get("/feeling", {
    params: {
      userId,
    },
  });

  return response.data;
};

export const addFeeling = async ({ userId, name, causeTypeId, teamId }) => {
  const response = await axiosClient.post("/feeling", {
    userId,
    name,
    causeTypeId,
    teamId
  });

  return response.data;
};
